export enum ErrorCodeEnum {
    BadRequest = 400,
    NotAuthorized = 401,
    AccessDenied = 403,
    NotFound = 404,
}
